(function ($) {
 
  TweenMax.set($('.ani'), { scale: 0.9, alpha: 0 });

  $("#btn1").click(function(e) {
    $('html,body').animate({
        scrollTop: $("#product_features_featureImgBlk").offset().top - $('.fixed_menu').height()
    },
      1000);
  });

  $("#btn2").click(function(e) {
      $('html,body').animate({
          scrollTop: $("#product_spec").offset().top - $('.fixed_menu').height()
      },
      1000);
  });

  $("#btn3").click(function(e) {
      $('html,body').animate({
          scrollTop: $("#product_buy").offset().top - $('.fixed_menu').height()
      },
      1000);
  });

  window.addEventListener('scroll',winScroll);
  function winScroll(e){
    let $now_Top = $(window).scrollTop();
    let $now_bottom = $now_Top+$(window).height();

    if ( $now_bottom >= $('.USB_A').offset().top )  {
      $('.USB_A .feature_intro_img').addClass("animated fadeIn");
    }

    if ( $now_bottom >= $('.USB_A').offset().top )  {
      $('.USB_A .feature_intro_pad_img').addClass("animated fadeIn");
    }

    if ( $now_bottom >= $('.SD_microSD').offset().top )  {
      $('.SD_microSD .feature_intro_img').addClass("animated fadeIn");
    }

    if ( $now_bottom >= $('.SD_microSD').offset().top )  {
      $('.SD_microSD .feature_intro_pad_img').addClass("animated fadeIn");
    }

    if ( $now_bottom >= $('.feature_one_intro').offset().top )  {
      $('.feature_one_intro .demo_img').addClass("animated fadeIn");
    }

    if ( $now_bottom >= $('.feature_one_intro .left_intro .icon_img').offset().top )  {
      $('.feature_one_intro .left_intro .icon_img').addClass("animated fadeIn");
    }

    if ( $now_bottom >= $('.feature_one_intro .right_intro .icon_img').offset().top )  {
      $('.feature_one_intro .right_intro .icon_img').addClass("animated fadeIn");
    }

  }

  $('.slide').slick({
    dots: true,
    infinite: true,
    autoplay: true,
    speed: 1000,
    autoplaySpeed: 5000,
    slidesToShow: 1,
    adaptiveHeight: true,
    arrows: false,
    fade: true,
    responsive: [
      {
        breakpoint: 569,
        settings: {
          dots: false,
        }
      }
    ]
  });
})($);